// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__16bkm","author":"Table_author__19wA6","authorImage":"Table_authorImage__2CKP4","unreadRow":"Table_unreadRow__1j5Qf"};